import { TableColumn } from '@/config/types';

export const getTableColumns = ({
  isMobile,
  hideColumnsForDeleteMode,
}: {
  isMobile: boolean;
  hideColumnsForDeleteMode?: boolean;
}) => {
  const columnsDesktop: TableColumn[] = [
    { name: 'channel', label: '', align: 'left' },
    { name: 'sentTo', label: 'SENT_TO', align: 'left', colWidth: '100px' },
    { name: 'createdAt', label: 'CREATION_DATE', align: 'left', colWidth: '160px' },
    { name: 'status', label: 'DELIVERY_STATUS', align: 'left' },
    { name: 'deliveredAt', label: 'DELIVERED_AT', align: 'left', colWidth: '160px' },
    { name: 'subject', label: 'MESSAGE_SUBJECT', align: 'left' },
  ];
  const columnsMobile: TableColumn[] = [
    { name: 'channel', label: ' ', align: 'left', sticky: true },
    { name: 'sentTo', label: 'SENT_TO', align: 'left', colWidth: '100px' },
    { name: 'createdAt', label: 'CREATION_DATE', align: 'left', colWidth: '160px' },
    { name: 'status', label: 'DELIVERY_STATUS', align: 'left' },
    { name: 'deliveredAt', label: 'DELIVERED_AT', align: 'left', colWidth: '160px' },
    { name: 'subject', label: 'MESSAGE_SUBJECT', align: 'left' },
  ];

  const columnsToHideForDeleteMode = [''];

  const hideMoreActionsColumnIfNeeded = (columns, hideColumnsForDeleteMode) => {
    if (hideColumnsForDeleteMode) {
      return columns.filter((column) => !columnsToHideForDeleteMode.includes(column.name));
    }
    return columns;
  };

  return isMobile
    ? hideMoreActionsColumnIfNeeded(columnsMobile, hideColumnsForDeleteMode)
    : hideMoreActionsColumnIfNeeded(columnsDesktop, hideColumnsForDeleteMode);
};
